module.exports = __webpack_public_path__ + "static/media/15.649f8e36.jpg";